var map = {
	"./2fa-warning.svg": 89207,
	"./RegaIcon.svg": 18451,
	"./add-media.svg": 43627,
	"./add-photo.svg": 39059,
	"./add.svg": 71480,
	"./agenstLogo.svg": 81246,
	"./agents.svg": 11753,
	"./apartment.svg": 90519,
	"./area.svg": 45752,
	"./arrow-left.svg": 65648,
	"./arrow-right.svg": 76415,
	"./arrow-table-left.svg": 51825,
	"./arrow-table-right.svg": 92380,
	"./arrowLongWhite.svg": 5803,
	"./attach-file.svg": 82019,
	"./attachment-black.svg": 44462,
	"./basket-red.svg": 85095,
	"./basket.svg": 8989,
	"./bathtub.svg": 86661,
	"./bed1.svg": 8561,
	"./build-outlined.svg": 39700,
	"./building.svg": 44051,
	"./calendar-icon.svg": 85357,
	"./calendar.svg": 85033,
	"./camera.svg": 58854,
	"./cancel.svg": 92045,
	"./check-black.svg": 99999,
	"./check-green.svg": 72583,
	"./check.svg": 82497,
	"./close.svg": 35837,
	"./dashboard.svg": 17461,
	"./delete-red.svg": 72288,
	"./delete.svg": 90930,
	"./doc.svg": 31075,
	"./download.svg": 91303,
	"./dropdown.svg": 46612,
	"./edit-black.svg": 16393,
	"./edit-blue.svg": 62836,
	"./edit-fill-blue.svg": 96912,
	"./edit.svg": 975,
	"./empty-group.svg": 33004,
	"./empty-logo.svg": 40822,
	"./empty-media.svg": 72321,
	"./empty-proj-img.svg": 76792,
	"./empty-staff.svg": 24747,
	"./empty-unit-design.svg": 91904,
	"./empty-unit.svg": 6037,
	"./empty-user.svg": 70318,
	"./exel.svg": 11151,
	"./fridge.svg": 21712,
	"./google-point.svg": 59587,
	"./image.svg": 83922,
	"./info.svg": 36947,
	"./link-arrow-right.svg": 83930,
	"./link.svg": 31119,
	"./logo-white.svg": 46174,
	"./logo.svg": 26962,
	"./logout.svg": 34277,
	"./map-black.svg": 6209,
	"./mediaEmptyIcon.svg": 65015,
	"./more.svg": 916,
	"./move.svg": 45299,
	"./nafath.svg": 64187,
	"./pdf.svg": 37523,
	"./pin.svg": 92528,
	"./placeholder.svg": 15850,
	"./plus.svg": 24491,
	"./poligon.svg": 28975,
	"./ppt.svg": 62197,
	"./preview.svg": 97881,
	"./project.svg": 31814,
	"./refresh-black.svg": 93818,
	"./refresh.svg": 32304,
	"./regaLogo.svg": 20349,
	"./request.svg": 20402,
	"./reservations-no-data.svg": 42767,
	"./search.svg": 64343,
	"./settings.svg": 20716,
	"./sofa.svg": 34798,
	"./staff.svg": 487,
	"./stairs.svg": 35137,
	"./success.svg": 50052,
	"./tooltipIcon.svg": 5783,
	"./uncompleted-gray.svg": 78667,
	"./uncompleted.svg": 89609,
	"./undo.svg": 57305,
	"./unit.svg": 90393,
	"./upload.svg": 50600,
	"./user-filled.svg": 43151,
	"./video.svg": 7680,
	"./view.svg": 93436,
	"./villa.svg": 69573,
	"./warn-img.svg": 49693,
	"./warn-outlined-blue.svg": 19563,
	"./warn-outlined.svg": 49938,
	"./warn-text.svg": 50533,
	"./website.svg": 9386,
	"./website/empty-image.svg": 98700,
	"./xls.svg": 8462
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46669;